import FreelanceInfo from './FreelanceInfo'
import FullTimeInfo from './FullTimeInfo'
import GeneralInfo from './GeneralInfo'
import cloneDeep from 'lodash/cloneDeep'
import Channel from '@/models-ts/user/Channel'
import Education from '@/models-ts/user/Education'
import PortfolioProject from '@/models-ts/user/PortfolioProject'
import WorkExperience from '@/models-ts/user/WorkExperience'

export default class MyFreelancerProfile {
  generalInfo: GeneralInfo
  freelanceInfo: FreelanceInfo
  fulltimeInfo: FullTimeInfo
  workExperience: Array<WorkExperience>
  educations: Array<Education>
  channels: Array<Channel>
  portfolio: Array<PortfolioProject>

  constructor({
    generalInfo,
    workExperience,
    freelanceInfo,
    fulltimeInfo,
    educations,
    channels,
    portfolio = [],
  }: Partial<MyFreelancerProfile>) {
    Object.assign(this, cloneDeep({ generalInfo, freelanceInfo, workExperience, educations, channels, portfolio, fulltimeInfo }))
  }

  static fromServer(props: LX.MyFreelancerProfile) {
    return new MyFreelancerProfile({
      generalInfo: GeneralInfo.fromServer(props),
      freelanceInfo: FreelanceInfo.fromServer(props),
      fulltimeInfo: FullTimeInfo.fromServer(props),
      educations: (props.relations.Education || []).map(Education.fromServer),
      channels: (props.relations.Channel || []).map(Channel.fromServer),
      workExperience: (props.relations.Experience || []).map(WorkExperience.fromServer),
      portfolio: (props.relations.Portfolio || []).map(PortfolioProject.fromServer),
    })
  }
}
